import React from 'react'
import { Close } from './Buttons'
import { MdClose } from "react-icons/md";

import'./pagetitle.css'
const PageTitle = ( {title,onClick}) => {
  return (
    <div className='d-flex justify-content-between p-3 title-bg'>
        <div className='regular text-white'>{title}</div>
        <div>
            <Close label={<MdClose style={{ color: "white", fontSize: "24px", cursor: "pointer" }} />} onClick={onClick}/>
        </div>
    </div>
  )
}

export default PageTitle